
import {defineComponent, PropType} from 'vue'
import {PagerHtmlItem} from "@/types";

export default defineComponent({
    name: "PagerHtmlItem",
    props: {
        pagerItem: {
            type: Object as PropType<PagerHtmlItem>,
            required: true,
        },
        key: {
            type: String,
            required: true,
        }
    }
})
